import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentNumberSettingRoutingModule } from './document-number-setting-routing.module';
import { DocumentNumberSettingComponent } from './document-number-setting.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    DocumentNumberSettingRoutingModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [DocumentNumberSettingComponent]
})
export class DocumentNumberSettingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting.module.ts